var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1ca0db;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16035",
    "data-name": "Path 16035",
    className: "cls-1",
    d: "M5.676,19.3V95.7H109.324"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3634",
    "data-name": "Group 3634"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598",
    "data-name": "Rectangle 1598",
    className: "cls-1",
    x: 17.657,
    y: 77.998,
    width: 6.954,
    height: 9.812
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1599",
    "data-name": "Rectangle 1599",
    className: "cls-1",
    x: 32.627,
    y: 73.342,
    width: 6.954,
    height: 14.468
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1600",
    "data-name": "Rectangle 1600",
    className: "cls-1",
    x: 47.598,
    y: 66.198,
    width: 6.954,
    height: 21.612
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1601",
    "data-name": "Rectangle 1601",
    className: "cls-1",
    x: 62.569,
    y: 56.561,
    width: 6.954,
    height: 31.249
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1602",
    "data-name": "Rectangle 1602",
    className: "cls-1",
    x: 77.539,
    y: 43.277,
    width: 6.954,
    height: 44.533
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1603",
    "data-name": "Rectangle 1603",
    className: "cls-1",
    x: 92.582,
    y: 27.47,
    width: 6.954,
    height: 60.34
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    className: "cls-1",
    d: "M17.657,67.491c40.169-12.814,65.353-47.5,65.353-47.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16037",
    "data-name": "Path 16037",
    className: "cls-1",
    d: "M70.18,23.09l12.825-3.1-.082,13.355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.add44b19711d95e52ce9f803055d458a.svg";
export { ForwardRef as ReactComponent };